// extracted by extract-css-chunks-webpack-plugin
module.exports = {"embed":"Embed__embed","embed__lcly":"Embed__embed__lcly","embed__lclyStoreLocator":"Embed__embed__lclyStoreLocator","embed__elfSight":"Embed__embed__elfSight"};